import { useQuery } from '@tanstack/react-query'

/** Module danh mục địa chỉ cũ / mới + bộ đổi (packages/common/src/geo/admin-areas). */
export type AdminAreas = typeof import('@shoptrack/common/admin-areas')

/** Tải lười một lần mỗi phiên (~100 KB nén) — không nằm trong bundle chính. */
export function useAdminAreas() {
  return useQuery({
    queryKey: ['admin-areas'],
    queryFn: (): Promise<AdminAreas> => import('@shoptrack/common/admin-areas'),
    staleTime: Infinity,
    gcTime: Infinity,
    structuralSharing: false,
    retry: 2,
  })
}
